var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.authenticatedUser.isLoggedIn || _vm.options.allowGuestFeedbacks
      ? _c("div", { staticClass: "createFeedback" }, [
          _c("div", { staticClass: "stars" }, [
            _c(
              "fieldset",
              [
                _c("legend", [
                  _c("span", { staticClass: "visually-hidden" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Feedback::Feedback.feedbackTextLegend")
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._l([5, 4, 3, 2, 1], function(i) {
                  return [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.feedback.ratingValue,
                          expression: "feedback.ratingValue"
                        }
                      ],
                      key: "star_input_" + i,
                      class: "star star-" + i,
                      attrs: {
                        id: "star-" + i + _vm._uid,
                        type: "radio",
                        name: "ratingValue" + _vm._uid
                      },
                      domProps: {
                        value: i,
                        checked: _vm._q(_vm.feedback.ratingValue, i)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.feedback, "ratingValue", i)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        key: "star_label_" + i,
                        class: "star star-" + i,
                        attrs: { for: "star-" + i + _vm._uid }
                      },
                      [
                        _c("span", { staticClass: "visually-hidden" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Feedback::Feedback.feedbackAverageLabel",
                                { count: i }
                              )
                            )
                          )
                        ])
                      ]
                    )
                  ]
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm.ratingMissing
            ? _c("p", { staticClass: "feedback-error alert alert-danger" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$translate("Feedback::Feedback.ratingRequired")
                    ) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.authenticatedUser.isLoggedIn && _vm.options.allowGuestFeedbacks
            ? _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.feedback.authorName,
                      expression: "feedback.authorName"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "author",
                    type: "text",
                    name: "author",
                    placeholder: _vm.$translate(
                      "Feedback::Feedback.authorName"
                    ),
                    disabled:
                      _vm.authenticatedUser.limitReached ||
                      !_vm.authenticatedUser.hasPurchased
                  },
                  domProps: { value: _vm.feedback.authorName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.feedback, "authorName", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "position-absolute",
                    attrs: { for: "author" }
                  },
                  [
                    _c("span", { staticClass: "visually-hidden" }, [
                      _vm._v(
                        _vm._s(_vm.$translate("Feedback::Feedback.authorName"))
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.feedback.honeypot,
                      expression: "feedback.honeypot"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "feedback-textfield",
                    type: "text",
                    name: "feedback-textfield",
                    "aria-hidden": "true",
                    tabindex: "-1"
                  },
                  domProps: { value: _vm.feedback.honeypot },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.feedback, "honeypot", $event.target.value)
                    }
                  }
                }),
                _c(
                  "label",
                  {
                    staticClass: "position-absolute",
                    attrs: { for: "feedback-textfield" }
                  },
                  [
                    _c("span", { staticClass: "visually-hidden" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Feedback::Feedback.honeypotLabel")
                        )
                      )
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.feedback.title,
                  expression: "feedback.title"
                }
              ],
              staticClass: "form-control",
              class: { "is-invalid": _vm.titleMissing },
              attrs: {
                id: "title",
                type: "text",
                name: "title",
                placeholder: _vm.$translate("Feedback::Feedback.title"),
                disabled:
                  _vm.authenticatedUser.limitReached ||
                  !_vm.authenticatedUser.hasPurchased
              },
              domProps: { value: _vm.feedback.title },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.feedback, "title", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "position-absolute", attrs: { for: "title" } },
              [
                _c("span", { staticClass: "visually-hidden" }, [
                  _vm._v(_vm._s(_vm.$translate("Feedback::Feedback.title")))
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "invalid-feedback" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$translate("Feedback::Feedback.titleRequired")) +
                  "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.feedback.message,
                  expression: "feedback.message"
                }
              ],
              staticClass: "form-control",
              attrs: {
                id: "message",
                name: "message",
                rows: "3",
                placeholder: _vm.$translate("Feedback::Feedback.reviewMessage"),
                disabled:
                  _vm.authenticatedUser.limitReached ||
                  !_vm.authenticatedUser.hasPurchased
              },
              domProps: { value: _vm.feedback.message },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.feedback, "message", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "position-absolute", attrs: { for: "message" } },
              [
                _c("span", { staticClass: "visually-hidden" }, [
                  _vm._v(
                    _vm._s(_vm.$translate("Feedback::Feedback.reviewMessage"))
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _vm.authenticatedUser.limitReached
            ? _c(
                "div",
                {
                  directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                  staticClass: "feedback-tooltip-wrapper",
                  attrs: {
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "data-original-title": _vm.$translate(
                      "Feedback::Feedback.maximumNumberOfFeedbacksReached"
                    )
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-appearance",
                      attrs: { disabled: "" }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$translate("Feedback::Feedback.submitReview")
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ]
              )
            : !_vm.authenticatedUser.hasPurchased
            ? _c(
                "div",
                {
                  directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                  staticClass: "feedback-tooltip-wrapper",
                  attrs: {
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "data-original-title": _vm.$translate(
                      "Feedback::Feedback.errorDoesntOwnProduct"
                    )
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-appearance",
                      attrs: { disabled: "" }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$translate("Feedback::Feedback.submitReview")
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-appearance",
                  attrs: { disabled: _vm.isLoading },
                  on: {
                    click: function($event) {
                      return _vm.createFeedback()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$translate("Feedback::Feedback.submitReview")
                      ) +
                      "\n    "
                  )
                ]
              )
        ])
      : _c("div", [
          _c("div", { staticClass: "alert alert-info" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$translate("Feedback::Feedback.logInCustomerReviews")
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary btn-appearance",
              attrs: { "data-toggle": "modal", href: "#login" },
              on: {
                click: function($event) {
                  return _vm.createLoginModal()
                }
              }
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$translate("Feedback::Feedback.login")))
              ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-user",
                attrs: { "aria-hidden": "true" }
              })
            ]
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }